import React, {useState} from 'react';
import {eulaVersion} from './utils/eula';

interface EulaPageProps {
  onAccept: () => Promise<void>;
  onDecline: () => void;
  busy?: boolean;
}

export default function EulaPage({onAccept, onDecline, busy = false}: EulaPageProps) {
  const [agreed, setAgreed] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleAccept = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!agreed || submitting) return;
    setSubmitting(true);
    try {
      await onAccept();
    } finally {
      setSubmitting(false);
    }
  };

  const isLoading = busy || submitting;

  return (
    <div
      className="eula-gate"
      data-testid="eula-gate"
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--color-bg, #f5f5f5)',
        zIndex: 9999,
        padding: '24px',
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
          width: '100%',
          maxWidth: '760px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          padding: '32px',
        }}
      >
        <h1 style={{margin: 0, fontSize: '1.4rem'}}>Updated User License Agreement</h1>
        <p style={{margin: 0, color: '#555'}}>
          We have updated our User License Agreement. Please acknowledge you have read and agree to the new User License Agreement before using the application.
        </p>



        <form onSubmit={handleAccept} style={{display: 'flex', flexDirection: 'column', gap: '16px'}}>
          <a href={`/eula/metrcid-${eulaVersion}.pdf`} target="_blank" rel="noopener noreferrer" className="label" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginBottom: 4 }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
              <line x1="9" y1="13" x2="15" y2="13"/>
              <line x1="9" y1="17" x2="15" y2="17"/>
              <polyline points="9 9 10 9"/>
            </svg>
            View User License Agreement
          </a>
          <label
            style={{display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', userSelect: 'none'}}
          >
            <input
              type="checkbox"
              data-testid="eula-agree-checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              disabled={isLoading}
              style={{width: '16px', height: '16px', flexShrink: 0}}
            />
            I agree to the User License Agreement.
          </label>

          <div style={{display: 'flex', gap: '12px', justifyContent: 'flex-end'}}>
            <button
              type="button"
              className="button"
              data-testid="eula-decline-button"
              onClick={onDecline}
              disabled={isLoading}
              style={{minWidth: '80px'}}
            >
              Decline
            </button>
            <button
              type="submit"
              className="button cta"
              data-testid="eula-accept-button"
              disabled={!agreed || isLoading}
              style={{minWidth: '140px'}}
            >
              {isLoading ? 'Saving…' : 'Accept & Continue'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
